import React from "react";
import styled from "styled-components";

interface Props {
  label: string;
  isSelected: boolean;
  onCheckboxChange: (isChecked: boolean) => void;
  disabled?: boolean;
}

const CheckBoxContainer = styled.div`
  margin: 0.5em;
`;

const StyledInput = styled.input`
  :focus {
    border: solid var(--color-bg-tertiery);
  }
`;

const Checkbox = ({ label, isSelected, onCheckboxChange, disabled }: Props) => (
  <CheckBoxContainer>
    <label>
      <StyledInput
        type="checkbox"
        name={label}
        checked={isSelected}
        onChange={(e: any) => onCheckboxChange(e.target.checked)}
        disabled={disabled}
      />
      {label}
    </label>
  </CheckBoxContainer>
);

export default Checkbox;
